import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/cashout';
import {createCashAppCashOutRequest} from '../../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';

import LoaderPage from '../../../components/loader_page';

import Enter from './enter';
import Alert from './alert';

export default () => {
    const {wallet, cashapp_cashout} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate();

    const [stage, setStage] = useState('enter'),
          [data, setData] = useState(null);

    if(stage === "enter")
        return <Enter onNext={data => {
            dispatch(createCashAppCashOutRequest(data, navigate));
            setStage('request');
        }} wallet={wallet} />

    return <Alert order={cashapp_cashout} />
}